export class IdTokenState {
    public idToken: string = '';
    public isAuth: boolean = false;
    public idTokenLifeTime: number = 0;
}

